export default __webpack_public_path__ + "static/media/three_stars.f581905a.svg";